<ng-template>
  <ng-content></ng-content>
  <ng-template [cdkPortalOutlet]="_portal"></ng-template>
</ng-template>
